import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConnectTradeDeskAgencyComponent } from './connect-trade-desk-agency.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: ConnectTradeDeskAgencyComponent
      }
    ])
  ],
  exports: [RouterModule]
})
export class ConnectTradeDeskAgencyRoutingModule {}
